export const environment = {

  production: true,
  kratosPublic: 'https://image.org.by/kratos',
    baseUrl: 'image.org.by/histology',
	port: null
};
